<div class="rpc-notification-item" (click)="onNotificationClick()"
    [class.rpc-notification-item--read]="notification.isViewed"
    [class.rpc-notification-item--appointment]="notification.type === NotificationEventEntity.Appointment">

    <div class="rpc-notification-item-icon-wrap" [class]="notification.iconClass ?? ''">

        <rpc-icon class="rpc-notification-item-icon" [iconName]="notification.icon">
        </rpc-icon>

    </div>

    <div class="rpc-notification-item-title" wrapWords>
        {{ notification.translationInfo.key | translate:
        notification.translationInfo.params}}
    </div>

    <div class="rpc-notification-item-date">
        {{ notification.dateCreated | date: dateFormat}}
    </div>

    <notification-checkbox class="rpc-notification-group-btn" [checked]="!notification.isViewed"
        (cliked)="onToggleNotification()">
    </notification-checkbox>

    @if (notification.type === NotificationEventEntity.ListingActivity || notification.type ===
    NotificationEventEntity.ExternalListing) {
    <div class="rpc-notification-item-inner">

        <div class="rpc-notification-item-listing" [title]="notification.listingAddress">

            <default-image class="rpc-notification-item-listing-img"
                [image]="(notification.data | cast: ListingNotification).listingUrl" [useBackgroundImage]="true">
            </default-image>

            <div class="rpc-notification-item-address">
                {{ notification.listingAddress }}
            </div>

        </div>

    </div>
    }

    @if (notification.type === NotificationEventEntity.Comment) {
    <div class="rpc-notification-item-inner">

        <div class="rpc-notification-item-address" [title]="notification.listingAddress">
            {{ notification.listingAddress }}
        </div>

        <div class="rpc-notification-item-comment">
            {{(notification.data | cast: CommentNotification).text}}
        </div>

    </div>
    }

    @if (notification.type === NotificationEventEntity.Appointment) {
    <appointment-notification class="rpc-notification-item-inner" [listingAddress]="notification.listingAddress"
        [notificationId]="notification.notificationId" [notificationAction]="notification.action"
        [appointment]="(notification.data| cast: AppointmentNotification)"
        (navigateToNotificationEntity)="onNavigateToNotificationEntity($event)"
        (statusChanged)="onAppointmentStatusChanged($event)">
    </appointment-notification>
    }

</div>